import React from 'react';
import {Img} from "../Img";
import LanguageSwitcher from "../languageSwitcher";
import MainBurgerMenu from "./BurgerMenuMain";
import {Heading} from "../Heading";
import {Link} from "react-router-dom";

export default function MainHeaderWithBurger() {
    return (
        <div className="px-5 pt-5 sm:px-[16px] sm:pt-[22px] container-xs">
            <div className="flex items-center justify-between">
                <Link to={'/main'}>
                <Img src="/images/logo_header.svg"
                     className="w-[167px] h-5"/>
                </Link>

                <div className="flex items-center gap-4">
                    <LanguageSwitcher/>
                    <button
                        className="w-[152px] h-[32px] rounded-[30px] bg-[#0C88F0] flex items-center justify-center px-2 sm:hidden"
                    >
                        <img
                            src={"/images/callUsIcon.svg"}
                            alt="call usIcon"
                        />
                        <Heading
                            size={"desktop_body_s"}
                            className={"text-[#FFFFFF] w-auto flex-row"}>
                            <a href="tel:+74955427541">
                                +7(495)542-75-41
                            </a>
                        </Heading>
                    </button>
                    <MainBurgerMenu/>
                </div>
            </div>
        </div>
    );
}
